import { callApi } from "./api.service";

//Define the function to get billing address(Token required).
export const GetBillingAddress = async (
  getToken: () => Promise<string | null>
) => {
  return await callApi("/api/get-billing-address", "GET", true, getToken);
};

export const UpdateBillingDetails = async (
  getToken: () => Promise<string | null>,
  data:any
) => {
  return await callApi("/api/update-billing-address", "PUT", true, getToken, data);
};

export const CheckBillingDetails = async (
  getToken: () => Promise<string | null>
) => {
  return await callApi("/api/check-billing-address", "GET", true, getToken);
};